import {
  ApplicationInsights,
  ITelemetryItem,
  SeverityLevel
} from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import { appInsightsConfig } from 'src/config';

const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();
const ai = new ApplicationInsights({
  config: {
    connectionString: appInsightsConfig.connectionString,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    },
    autoTrackPageVisitTime: true
  }
});

ai.appInsights.addTelemetryInitializer((envelope: ITelemetryItem) => {
  envelope.tags = envelope.tags || [];
  envelope.tags.push({ 'ai.cloud.role': 'exo-administration' });

  if (process.env.NODE_ENV === 'development') {
    console.log('[telemetry]', envelope.baseType, envelope);
    return false;
  }
  return true;
});

ai.loadAppInsights();

export const severityLevel = SeverityLevel;
export const appInsights = ai.appInsights;

export function SetAuthenticatedUserContext(id: string): void {
  ai.setAuthenticatedUserContext(id);
}
